// extracted by mini-css-extract-plugin
export default {"container":"searchBar_container__7BnL2","input-wrapper":"searchBar_input-wrapper__lVSux"};